<template>
	<v-row>
		<BottomNavigationContainer v-if="menu.length > 1" :menu="menu" />

		<v-col cols="12" class="d-none d-md-block">
			<ToolbarContainer :menu="menu" />
			<v-toolbar elevation="1" height="25" rounded="b">
				<Breadcrumbs />
			</v-toolbar>
		</v-col>

		<v-col cols="12" lg="12">
			<router-view />
		</v-col>
	</v-row>
</template>

<script>
import Breadcrumbs from "../Widgets/Breadcrumbs";
import ToolbarContainer from "../Widgets/ToolbarContainer";
import BottomNavigationContainer from "../Widgets/BottomNavigationContainer";

export default {
	name: "SeguroContainer",
	components: { Breadcrumbs, ToolbarContainer, BottomNavigationContainer },
	data: () => ({
		menu: [],
	}),
	methods: {
		montarMenu() {
			let m = [];

			if (this.permissao("seguro_prestamista")) {
				m.push({
					titulo: "Sorte Premiada",
					titulo_app: "Sorte Premiada",
					icon: "mdi-store-outline",
					to: "/seguro",
					tooltip:
						"Modulo de faturamento de bilhetes de seguro sorte premiada",
				});
			}

			if (this.permissao("seguro_prestamista")) {
				m.push({
					titulo: "Seguro Prestamista",
					titulo_app: "Prestamista",
					icon: "mdi-store-outline",
					to: "/seguro/prestamista",
					tooltip:
						"Modulo de faturamento de bilhetes de seguro prestamista",
				});
			}

			if (this.permissao("seguro_listar")) {
				m.push({
					titulo: "Seguros",
					titulo_app: "Seguros",
					icon: "mdi-store-outline",
					to: "/seguro/listar",
					tooltip: "Lista de seguros Alfa do sistema Gestor",
				});
			}

			this.menu = m;
		},
	},
	mounted() {
		this.montarMenu();
	},
};
</script>

<style scoped>
</style>